import type { SVGProps } from 'react'

// Two stacked up-chevrons. Used by StackedCards' Collapse pill (per
// Figma node `1854:46163`) and reserved for any other "collapse a
// peek-stack" affordance. Lucide-equivalent of `chevrons-up`.

export default function ChevronUpDouble(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <polyline points="17 11 12 6 7 11" />
      <polyline points="17 18 12 13 7 18" />
    </svg>
  )
}
